import { Brand, BrandImport, BrandImportRst } from "../types/brand";
import { ProductInventory } from "../types/product";
import { get, post } from "./fetch.core";

interface BrandListResponse {
  items: Brand[];
  total: number;
  page: number;
  pageSize: number;
}

async function listBrands(page: number, size: number): Promise<BrandListResponse> {
  const queryParams = new URLSearchParams({
    "paging.page": page.toString(),
    "paging.size": size.toString(),
  });

  const res = await get<BrandListResponse>(`/admin/brand/list?${queryParams.toString()}`);
  return res.data;
}

async function getBrand(id: string) {
  const res = await get<Brand>(`/admin/brand/get?id=${id}`);
  return res.data;
}

async function getSingleBrandInventory(brandId: string) {
  // if (brandId !== "664580f6aedbdd0e2f808d34") return [];

  const res = await get<ProductInventory>(`/admin/brand/getSingleBrandInventory?brandId=${brandId}`);
  return res.data;
}

export async function importBrands(brandImports: BrandImport[]) {
  const rst = await post<BrandImportRst[]>("/admin/brand/import", { brands: brandImports });
  return rst.data;
}

const obj = {
  listBrands,
  getBrand,
  getSingleBrandInventory,
  importBrands,
};

export default obj;
